//////////////////////////////////////////////////////////////////////////////
// Routes
//////////////////////////////////////////////////////////////////////////////
export const ROUTE_NOT_FOUND = 'not-found'
export const ROUTE_PROJECT = 'project'
export const ROUTE_PROJECT_OFFER = 'offer'
export const ROUTE_PROJECT_CUSTOMER_SPEC = 'spec'
export const ROUTE_PROJECT_FACTORY_SPEC = 'carpentry-spec'

//////////////////////////////////////////////////////////////////////////////
// Route params
//////////////////////////////////////////////////////////////////////////////
export const ROUTE_PARAM_PROJECT_ID = 'projectId'
